module.exports = __webpack_public_path__ + "media/images/2_2-e3d31adca616f7afcf73ffe60687002f.png";